var quantityLabel = "Cantidad";
var quantityFlyoutHeader = "Elige la cantidad";
var quantityFlyoutCTA = "Selecciona esta cantidad";
var closeButton = "Cerrar";
var pricePlaceholder = "…";
var priceLabel = "Precio";
var unitPriceLabel = "Precio unitario";
var incompatibilityMessage = "No disponible con otras selecciones: ";
var select = "Elegir…";
var percentSavings = "{{{PERCENT}}}% de ahorro";
var sale = "rebajas";
var amountSavings = "{{{AMOUNT}}} de ahorro / unidad";
var amountSavingsWithSale = "{{{AMOUNT}}} de ahorro / unidad + descuento";
var seeMoreQuantities = "Ver más cantidades";
var required = "Obligatorio";
var sample = "Muestra";
var estimatedQuantity = "Cantidad estimada";
var numberOfRecipients = "{{{COUNT}}} destinatarios";
var recommendedCallout = "Recomendado";
var newCallout = "Novedad";
var incompatibleLabel = "Incompatible";
var outOfStockCallout = "Agotado";
var dismissAlert = "Descartar alerta";
var unwindingMessage_1 = "Incompatible con {{{OPTION1}}} {{{ATTRIBUTE1}}}.";
var unwindingMessage_2 = "Incompatible con {{{OPTION1}}} {{{ATTRIBUTE1}}} y {{{OPTION2}}} {{{ATTRIBUTE2}}}.";
var unwindingMessage_3 = "Incompatible con {{{OPTION1}}} {{{ATTRIBUTE1}}}, {{{OPTION2}}} {{{ATTRIBUTE2}}} y {{{OPTION3}}} {{{ATTRIBUTE3}}}.";
var unwindingMessage_more = "Incompatible con más de {{{ATTRIBUTE_COUNT}}} opciones.";
var unwindingAlertMessage_1 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se ha deseleccionado {{{OPTION1}}} {{{ATTRIBUTE1}}}.";
var unwindingAlertMessage_2 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se han deseleccionado {{{OPTION1}}} {{{ATTRIBUTE1}}} y {{{OPTION2}}} {{{ATTRIBUTE2}}}.";
var unwindingAlertMessage_3 = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se han deseleccionado {{{OPTION1}}} {{{ATTRIBUTE1}}}, {{{OPTION2}}} {{{ATTRIBUTE2}}} y {{{OPTION3}}} {{{ATTRIBUTE3}}}.";
var unwindingAlertMessage_more = "Para que sea compatible con {{{OPTION}}} {{{ATTRIBUTE}}}, se han deseleccionado más de {{{ATTRIBUTE_COUNT}}} opciones.";
var fullRangedHelperText = "De {{{MINIMUM}}} {{{UNIT}}} a {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Al menos {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Introduce un número de páginas entre {{{MINIMUM}}} y {{{MAXIMUM}}} (portada incluida) ";
var rangePartialRangedHelperTextForBooklets = "Al menos {{{MINIMUM}}} páginas (portada incluida) ";
var rangedGeneralInputError = "El valor de entrada no es válido";
var rangedBetweenRangesError = "Los números más cercanos son {{{LOWER}}} {{{UNIT}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "El número no puede exceder los 8 decimales";
var rangedMinInputValueError = "El número mínimo es {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "El número máximo es {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "El valor de entrada debe ser un número";
var requiredAttributeFieldError = "Introduce un valor entre {{{LOWER}}} y {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Los números más cercanos son {{{LOWER}}} páginas y {{{HIGHER}}} páginas ";
var rangedMinInputValueErrorForBooklets = "El número mínimo es {{{MINIMUM}}} páginas ";
var rangedMaxInputValueErrorForBooklets = "El número máximo es {{{MAXIMUM}}} páginas ";
var requiredAttributeFieldErrorForBooklets = "Introduce un número de páginas entre {{{LOWER}}} y {{{HIGHER}}} (portada incluida) ";
var requiredInformationToast = "Por favor, indica toda la información obligatoria.";
var esEs = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, esEs as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=es-es.json.mjs.map
